import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const EditProfile = () => {
  const [activeTab, setActiveTab] = useState("editProfile");
  const [profile, setProfile] = useState({
    name: "Admin Name",
    email: "admin@example.com",
  });
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [valueError, setValueError] = useState()
  const [error, setError] = useState("");
  const navigate = useNavigate()
  const handleTabChange = (tab) => setActiveTab(tab);

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
    setError("")
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPassword({ ...password, [name]: value });
    if(name === "newPassword"){
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
      if (!passwordRegex.test(value)) {
        setValueError(prev => {
          return {...prev, [name]: "Password must be at least 8 characters and include 1 uppercase, 1 lowercase, 1 number, and 1 special character."}
        })
      }else{
        setValueError(prev => {
          return {...prev, [name]: ""}
        })
      }
    }else if(name === "confirmPassword"){
        if(password.newPassword !== value){
          setValueError(prev => {
            return {...prev, [name]: "Confirm password and new password are not same"}
          })
        }else{
          setValueError(prev => {
            return {...prev, [name]: ""}
          })
        }
    }else{
      setValueError(prev => {
        return {...prev, [name]: ""}
      }) 
    }
  };

   const handleProfileSubmit = async(e) => {
      e.preventDefault();

      if (!profile?.name.trim()) {
        setError("Name is required.");
        return;
      }
      try {
        await axios.put(`${process.env.REACT_APP_BASE_URL}/updateDetails`, {name: profile?.name},{
          headers: {
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        navigate("/")
        setError(""); 
      } catch (error) {
        console.error("Error submitting data:", error);
      }
    };

  const handlePasswordSubmit = async(e) => {
    e.preventDefault();
      let errorLength = 0
      Object.keys(password).forEach(v => {
        if(!password[v]){
          setValueError(prev => {
            return {...prev, [v]: `${v.toLowerCase()} is required`}
          })
          errorLength = 1
        }
      })
       if(errorLength){
        return;
       }
      try {
        await axios.put(`${process.env.REACT_APP_BASE_URL}/admin/changepassword`, password,{
          headers: {
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("token")}`,
          },
        });
        localStorage.clear()
        navigate("/login")
        setValueError(""); 
      } catch (error) {
        console.error("Error submitting data:", error);
      }
  };

  const fetchData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-profile`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
    setProfile(response?.data?.users);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="min-h-screen flex bg-gray-100">
      <Sidebar />

      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold mb-6">Edit Profile</h1>

        {/* Tabs */}
        <div className="flex mb-6 border-b">
          <button
            onClick={() => handleTabChange("editProfile")}
            className={`px-6 py-2 ${
              activeTab === "editProfile"
                ? "border-b-2 border-blue text-blue font-bold"
                : "text-gray-600"
            }`}
          >
            Edit Profile
          </button>
          <button
            onClick={() => handleTabChange("changePassword")}
            className={`px-6 py-2 ${
              activeTab === "changePassword"
                ? "border-b-2 border-blue text-blue font-bold"
                : "text-gray-600"
            }`}
          >
            Change Password
          </button>
        </div>

        {/* Tab Content */}
        <div className="bg-white shadow-md rounded-lg p-6">
          {activeTab === "editProfile" && (
            <div>
              <h2 className="text-lg font-bold mb-4">Edit Profile</h2>
              <div className="mb-4">
                <label className="block font-bold mb-2">Name</label>
                <input
                  type="text"
                  name="name"
                  value={profile.name}
                  onChange={handleProfileChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full"
                />
                 {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
              </div>
              <div className="mb-4">
                <label className="block font-bold mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  disabled
                  value={profile.email}
                  onChange={handleProfileChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full"
                />
              </div>
              <button
                onClick={handleProfileSubmit}
                className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
              >
                Update Profile
              </button>
            </div>
          )}

          {activeTab === "changePassword" && (
            <div>
              <h2 className="text-lg font-bold mb-4">Change Password</h2>
              <div className="mb-4">
                <label className="block font-bold mb-2">Old Password</label>
                <input
                  type="password"
                  name="oldPassword"
                  value={password.oldPassword}
                  onChange={handlePasswordChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full"
                />
                {valueError?.oldPassword && <p className="text-red-500 text-sm mt-1">{valueError?.oldPassword}</p>}
              </div>
              <div className="mb-4">
                <label className="block font-bold mb-2">New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  value={password.newPassword}
                  onChange={handlePasswordChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full"
                />
                {valueError?.newPassword && <p className="text-red-500 text-sm mt-1">{valueError?.newPassword}</p>}
              </div>
              <div className="mb-4">
                <label className="block font-bold mb-2">Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={password.confirmPassword}
                  onChange={handlePasswordChange}
                  className="border border-gray-300 rounded-md px-4 py-2 w-full"
                />
                {valueError?.confirmPassword && <p className="text-red-500 text-sm mt-1">{valueError?.confirmPassword}</p>}
              </div>
              <button
                onClick={handlePasswordSubmit}
                className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
              >
                Update Password
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
